module.exports = __webpack_public_path__ + "img/aq.aq2405e38.svg";